import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ScheduleTime } from "../../models/ScheduleTime";
import {RootState} from "../store";

export interface ScheduleState {
  scheduleTimes: ScheduleTime[];
}

const initialState: ScheduleState = {
  scheduleTimes: [],
};
export const scheduleSlice = createSlice({
  name: "schedule",
  initialState,

  reducers: {
    setSchedules: (state, action: PayloadAction<ScheduleTime[]>) => {
      state.scheduleTimes = action.payload;
    },
    addSchedule: (state, action: PayloadAction<ScheduleTime>) => {
      state.scheduleTimes.push(action.payload);
    },
    deleteSchedule: (state, action: PayloadAction<ScheduleTime>) => {
      state.scheduleTimes.map((element: ScheduleTime, index: number) => {
        if (element.schedule.hour === action.payload.schedule.hour) {
          state.scheduleTimes.splice(index, 1);
        }
      });
    },
  },
});

export const { setSchedules, addSchedule, deleteSchedule } =
  scheduleSlice.actions;

export const selectSchedules = (state: RootState): ScheduleTime[] =>
  state.schedule.scheduleTimes;

export default scheduleSlice.reducer;
